import { User } from '../types/user';

/** Matches nav/admin API: superuser flag or ADMIN / SUPER_ADMIN role. */
export function isFlashAdmin(user: User | null | undefined): boolean {
  if (!user) return false;
  return (
    user.is_superuser ||
    user.role === 'ADMIN' ||
    user.role === 'SUPER_ADMIN'
  );
}
